export class Login {
  email = '';
  password = '';

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class ResetPassword extends Login {
  repeat_password ? = '';

  constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/login.model.ts